import { Flex } from 'antd'

import { useDarkTheme } from '@/contexts/DarkThemeContext'
import { useAppMessages } from '@/hooks/useAppMessages'
import { useEffect, useRef } from 'react'
import styles from './styles.module.scss'

export function RetroButtons() {
  const { showABButtons, isDarkTheme, processInput } = useDarkTheme()
  const prevShowABButtonsRef = useRef(showABButtons)
  const message = useAppMessages()

  useEffect(() => {
    if (prevShowABButtonsRef.current && !showABButtons && isDarkTheme) {
      message.success('Achievement unlocked! You can now use the dark theme.')
    }
    prevShowABButtonsRef.current = showABButtons
  }, [showABButtons, isDarkTheme, message])

  if (!showABButtons) return null
  return (
    <Flex gap={16} className={styles.container} align="center" justify="center">
      <button onClick={() => processInput('buttonB')} className={styles.button} data-button="b">
        B
      </button>

      <button onClick={() => processInput('buttonA')} className={styles.button} data-button="a">
        A
      </button>
    </Flex>
  )
}
